import { Observable, of } from 'rxjs';
import { ResponseData } from 'src/app/core/models/response';
import { RATE_TYPE } from 'src/app/features/institution/instution.constant';
import { Dropdown } from '../../models/dropdown';

export class RateTypeService {
  constructor() {}
  public getRateTypes(): Observable<ResponseData<Dropdown[]>> {
    return of({
      data: [
        {
          value: RATE_TYPE.semesterHour,
          label: 'Semester Hour'
        },
        {
          value: RATE_TYPE.quarterHour,
          label: 'Quarter Hour'
        },
        {
          value: RATE_TYPE.contactHour,
          label: 'Contact Hour'
        }
      ]
    });
  }
}
